import styled from 'styled-components'

const QuestionListItemNumberUi = styled.div`
  font-size: 20px;
  padding-right: 5px;
`

export default QuestionListItemNumberUi
